import { render, staticRenderFns } from "./FacilityUserAddRoleDialog.vue?vue&type=template&id=58b79e8c&scoped=true"
import script from "./FacilityUserAddRoleDialog.ts?vue&type=script&lang=ts&external"
export * from "./FacilityUserAddRoleDialog.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b79e8c",
  null
  
)

export default component.exports